import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home/Home";
import ChineseProducts from "./pages/China/China";
import ThailandProducts from "./pages/Thailand/Thailand";
import ProductPage from "./pages/Products/Products";
import Chemical from "./pages/Chemical/Chemical";
import About from "./pages/About/About";
import Contact from "./pages/Contact/Contact";
import Faq from "./pages/Faq/faq";
import InquiryPage from "./pages/Inquiry/InquiryPage";
import FoodAndBeverages from "./pages/FoodAndBeverages/FoodAndBeverages";
import { InquiryProvider } from "./context/InquiryContext";
import "./App.css";

function App() {
  return (
    <Router>
      <InquiryProvider>
        <div className="app-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/China" element={<ChineseProducts />} />
            <Route path="/Thailand" element={<ThailandProducts />} />
            <Route path="/products" element={<ProductPage />} />
            <Route path="/chemical" element={<Chemical />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/about" element={<About />} />
            <Route path="/inquiry" element={<InquiryPage />} />
            <Route path="/foodandbeverages" element={<FoodAndBeverages />} />
          </Routes>
        </div>
      </InquiryProvider>
    </Router>
  );
}

export default App;